// node-modules
import ScrollMagic from 'scrollmagic';
import { TweenMax } from 'gsap/TweenMax';

// constants
import { SELECTORS } from '@/scripts/constants';

// other
import { StripesRevealer } from '@/components';
import { controller } from '@/components/_scrollmagic';

export default function stripesRevealer(container) {
  // default animation
  const defaultRevealers = container.querySelectorAll('[data-role="stripes-reveal"]');
  const scenes = [];

  defaultRevealers.forEach((revealerElement) => {
    let { duration, delay } = revealerElement.dataset;
    duration = parseFloat(duration);
    delay = parseFloat(delay);

    new StripesRevealer({ // eslint-disable-line no-new
      revealerElement,
      stripesCount: 6,
      stripesDirection: 'vertical',
    });

    scenes.push(new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: revealerElement,
      triggerHook: 0.9,
    }).on('start', () => {
      const stripes = revealerElement.querySelectorAll('.stripe');
      const target = revealerElement.querySelector('[data-role*="reveal-target"]');
      target.style.transitionDuration = `${duration + stripes.length * delay + 0.1}s`;
      if (stripes) {
        TweenMax.staggerFromTo(stripes, duration, { scaleY: 1 }, {
          scaleY: 0,
          transformOrigin: 'bottom center',
        }, delay);
        revealerElement.classList.add(SELECTORS.active);
      }
    })
      // .addIndicators({name: 'stripes'})
      .addTo(controller));
  });

  return scenes;
}




// WEBPACK FOOTER //
// ./components/_scrollmagic/scenes/stripes-revealer/stripes-revealer.js